import LAYOUT_CONST from 'constant';

export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};
// export const API_URL = 'http://localhost:8000';
export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = process.env.REACT_APP_API_URL;

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_AOfOTXLvD',
    appClientId: '3eau2osduslvb7vks3vsh9t7b0'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/';
export const DUPR_KEY = 'Y2stODNiZjkzNGYtZjQ5Ni00Mzc3LWZkYjgtMjdlZmQwZGViMGFkOmNzLWUyZDliZTk0MjYzNTRiMmJmOWViMTE4OWNkYWE3ZmY4';

export const HORIZONTAL_MAX_ITEM = 6;
// export const STRIPE_PK = 'pk_test_51OEFclCCKQ32fUSXoo3NCDOL99Ijn353LMQI2GbqT66IaHxzP08hyhu6JZ4VfXHxAyIx1GKujES4xgjV5Ib2UbzK004qfHAdc7';
export const STRIPE_PK = 'pk_live_51OEFclCCKQ32fUSX2nh2BvIZ19fEtyanTo1MRtGlUyOJ0e82aoO65SYbYUfhZHXVZHZ0E0Bqul8TAq4tkYe7zdc700lKcyEfBC';

export const MIXPANEL_TOKEN = 'dc27d06df5cae3c870da803a85225ab2';

const config = {
    layout: LAYOUT_CONST.VERTICAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'theme1', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;
